import { apiClient } from 'client/core/network/apiClient';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import {
  IProcedureBridgeOfficesQuery,
  IProcedureBridgeOfficesResult,
  IProcedureBridgeSearchDossierQuery,
  IProcedureBridgeSearchDossierResult,
  IProcedureBridgeListDossierTypologiesQuery,
  IProcedureBridgeListDossierTypologiesResult,
  IProcedureBridgeListDossierTypology,
  IProcedureBridgeListDocumentTypologiesQuery,
  IProcedureBridgeListDocumentTypology,
  IProcedureBridgeDossierTypology,
  IProcedureBridgeDocumentTypology,
  IProcedureBridgePublicDocument,
  IProcedureBridgeDocumentInfo,
  IProcedureBridgeAttachmentInfo,
  IProcedureBridgeDossier,
  IProcedureBridgeCategoryIndices,
  IProcedureBridgeAcl,
  IProcedureBridgeAclQuery,
  IProcedureBridgeCodeAdmQuery
} from 'common/dto/ProcedureBridgeDto';
import { IDataWithAuthToken } from 'server/schema/request/RequestService';

export const ProcedureBridgeApi = {
  /**
   * Elenco degli uffici, navigazione ad albero
   */
  listOffices: (opts: { query: IProcedureBridgeOfficesQuery }) =>
    apiClient.get<IProcedureBridgeOfficesResult>(`/procedures-bridge/offices`, {
      params: opts.query
    }),

  /**
   * Ricerca di un fascicolo a partire dal codice
   */
  searchDossier: (opts: { query: IProcedureBridgeSearchDossierQuery }) =>
    apiClient.get<IProcedureBridgeSearchDossierResult>(
      `/procedures-bridge/search-dossier`,
      { params: opts.query }
    ),

  /**
   * Elenco tipologie di fascicolo
   */
  listDossierTypologies: (opts: {
    query: IProcedureBridgeListDossierTypologiesQuery;
  }) =>
    apiClient.get<IProcedureBridgeListDossierTypology[]>(
      `/procedures-bridge/dossier-typologies`,
      { params: opts.query }
    ),

  /**
   * Dettaglio tipologia di fascicolo
   */
  getDossierTypology: (opts: {
    id: number;
    query: IProcedureBridgeCodeAdmQuery;
  }) =>
    apiClient.get<IProcedureBridgeDossierTypology>(
      `/procedures-bridge/dossier-typologies/${opts.id}`,
      { params: opts.query }
    ),

  /**
   * Elenco tipologie di documento
   */
  listDocumentTypologies: (opts: {
    query: IProcedureBridgeListDocumentTypologiesQuery;
  }) =>
    apiClient.get<IProcedureBridgeListDocumentTypology[]>(
      `/procedures-bridge/document-typologies`,
      { params: opts.query }
    ),

  /**
   * Dettaglio tipologia di documento
   */
  getDocumentTypology: (opts: {
    id: number;
    query: IProcedureBridgeCodeAdmQuery;
  }) =>
    apiClient.get<IProcedureBridgeDocumentTypology>(
      `/procedures-bridge/document-typologies/${opts.id}`,
      { params: opts.query }
    ),

  /**
   * Titolario
   */
  getCategoryIndices: (opts: { query: IProcedureBridgeCodeAdmQuery }) =>
    apiClient.get<IProcedureBridgeCategoryIndices>(
      `/procedures-bridge/category-indices`,
      { params: opts.query }
    ),

  /**
   * ACL
   */
  getACL: (opts: { query: IProcedureBridgeAclQuery }) =>
    apiClient.get<IProcedureBridgeAcl[]>(`/procedures-bridge/acl`, {
      params: opts.query
    }),

  /**
   * Lista documenti pubblici (root)
   */
  listRootPublicDocuments: (opts: { requestId: number }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgePublicDocument>[]>(
      `/requests/${opts.requestId}/dossier/documents`
    ),

  /**
   * Lista sotto fascicoli (root)
   */
  listRootSubdossiers: (opts: { requestId: number }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgeDossier>[]>(
      `/requests/${opts.requestId}/dossier/subdossiers`
    ),

  /**
   * Lista documenti pubblici (non root)
   */
  listPublicDocuments: (opts: { requestId: number; token: string }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgePublicDocument>[]>(
      `/requests/${opts.requestId}/dossier/subdossiers/${opts.token}/documents`
    ),

  /**
   * Lista sotto fascicoli (non root)
   */
  listSubdossiers: (opts: { requestId: number; token: string }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgeDossier>[]>(
      `/requests/${opts.requestId}/dossier/subdossiers/${opts.token}/subdossiers`
    ),

  /** Info Documento */
  getDocumentInfo: (opts: { requestId: number; token: string }) =>
    apiClient.get<IProcedureBridgeDocumentInfo>(
      `/requests/${opts.requestId}/document/${opts.token}`
    ),

  /** Info Allegati documento */
  getAttachments: (opts: { requestId: number; token: string }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgeAttachmentInfo>[]>(
      `/requests/${opts.requestId}/document/${opts.token}/attachments/`
    ),

  /** Token documento principale */
  getDocumentToken: (opts: { requestId: number }) =>
    apiClient.get<IDataWithAuthToken<IProcedureBridgeDocumentInfo>>(
      `requests/${opts.requestId}/document/token`
    )
};
